export default "__VITE_ASSET___s5uDF_k__"